export const TextFieldVariant = {
  NORMAL: 'normal',
  DENSE: 'dense'
};
export const TextFieldBorderColor = {
  MONO_500: 'mono_500',
  MONO_600: 'mono_600',
  NEGATIVE: 'negative',
  NEGATIVE_CONTRAST: 'negative_contrast'
};
export const TEXT_FIELD_DEFAULT_VARIANT = TextFieldVariant.NORMAL;